module.exports = __webpack_public_path__ + "img/product-banner_6.147ca983.png";